import { Dispatch, Action } from 'redux'
import { FeedbackFormMapDispatchReturnType } from './types/FeedbackFormMapDispatchReturnType'

export const FeedbackFormMapDispatch = (
  _dispatch: Dispatch<Action>
): FeedbackFormMapDispatchReturnType => {
  return {
  }
}
